import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import  './Navbar.css'
import iconcart from '../images/icon-cart.svg';
import cartImage from "../images/icon-cart.svg";
import profilePic from "../images/image-avatar.png";
import product1 from "../images/image-product-1-thumbnail.jpg";
import product2 from "../images/image-product-2-thumbnail.jpg";
import product3 from "../images/image-product-3-thumbnail.jpg";
import product4 from "../images/image-product-4-thumbnail.jpg";
import product5 from "../images/image-product-3.jpg";


const navbar = () => {

  return (
    <div>
      <nav class="navbar navbar-expand-lg bg-body-tertiary">
  <div class="container-fluid">
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarTogglerDemo01" aria-controls="navbarTogglerDemo01" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarTogglerDemo01">
      <a class="navbar-brand" href="#">Sneakers</a>
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <li class="nav-item">
          <a class="nav-link active" aria-current="page" href="#">Collections</a>
        </li>
        <li class="nav-item">
          <a class="nav-link active" aria-current="page" href="#">Men</a>
        </li>
        <li class="nav-item">
          <a class="nav-link active" aria-current="page" href="#">Women</a>
        </li>
        <li class="nav-item">
          <a class="nav-link active" aria-current="page" href="#">About</a>
        </li>
        <li class="nav-item">
          <a class="nav-link active" aria-current="page" href="#">Contact</a>
        </li>
      </ul>
      <form class="d-flex" role="search">
        <img src={iconcart} alt="" class="cart"></img>
        <img src={profilePic} alt="" class="avatar"></img>
      </form>
    </div>
  </div>
 
</nav>
<hr className='line' />
<section>
<div class="row row-cols-1 row-cols-md-2 g-4">
  <div class="col">
    <div class="card one" >
      <img src={product1} class="image" alt="..." />
      <div class="card-body">
      <img src={product2} class="image1" alt="..." />
      <img src={product3} class="image1" alt="..." />
      <img src={product4} class="image1" alt="..." />
      <img src={product5} class="image1" alt="..." />
      
      </div>
    </div>
  </div>
  <div class="col">
    <div class="card">
      
      <div class="card-body">
        <h5 class="card-title text">SNEAKER COMPANY</h5>
        <p class="card-text text2">Fall Limited Edition Sneakers</p>
        <p class="card-text text3">These low-profile sneakers are your perfect casual wear companion. Featuring a durable rubber outer sole,they'll withstand everything the weather can offer</p>
        <div class='same-line'><p class="card-text text4">$125.00 </p><span class='orange'>50%</span></div>
        <div className='buttons'>
        <button class='b'  >-</button>
        <button class='b1'>0</button>
        <button class='b'  >+</button>
        <button class='b5'> <img src={cartImage} class='cartw'/> &nbsp; Add to Cart</button>
        </div>
      </div>
    </div>
  </div>

</div>

    
</section>

</div>



  )
}

export default navbar
